import React from "react";
import "./RadioButton.scss";

import classNames from "classnames";
import { Input } from "@mui/base/Input";

import { ReactComponent as Unchecked } from "./unchecked.svg";
import { ReactComponent as Checked } from "./checked.svg";

interface RadioButtonProps {
  name: any;
  index: any;
  error: any;
  label: any;
  value: any;
  checked: boolean;
  className?: any;
  onChange: any;
}

export const RadioButton: React.FC<RadioButtonProps> = (props: RadioButtonProps) => {
  const { name, value, index, checked, label, error, className, onChange } = props;

  return (
    <div
      className={classNames({
        "rhf-checkbox": true,
        "rhf-checkbox--checked": checked,
        "rhf-checkbox--error": !!error,
      })}
    >
      {checked && <Checked />}
      {!checked && <Unchecked />}
      <label htmlFor={name + index}>
        <Input
          id={name + index}
          className={classNames({
            "rhf-checkbox--checked": checked,
            className,
          })}
          name={name}
          error={!!error}
          value={value}
          type="radio"
          onChange={onChange}
        />
        {label}
      </label>
    </div>
  );
};
